import { use } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';

import { ModalInstanceContext } from '../../../contexts/ModalContext';

interface PopulateSpaceReadyModalProps {
  testId?: string;
  videoUrl?: string;
}

export const PopulateSpaceReadyModal = ({
  videoUrl,
  testId,
}: PopulateSpaceReadyModalProps) => {
  const modalInstance = use(ModalInstanceContext);
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col justify-center items-center gap-3"
      {...getTestProps(testId, 'success-container')}
    >
      <h1 className="text-center font-bold text-3xl/[32px] mb-3 md:text-4xl/[32px]">
        {t('PopulateSpaceModal.ModalSuccess.Header')}
      </h1>
      <p className="text-center text-slate-900 mb-3 dark:text-slate-200">
        {videoUrl
          ? t('PopulateSpaceModal.ModalSuccess.CheckVideo')
          : t('PopulateSpaceModal.ModalSuccess.DataAdded')}
      </p>
      {videoUrl && (
        <div className="w-96 h-64 mb-3 sm:w-[550px] sm:h-[300px]">
          <iframe
            title="PopulateSpaceModal.ModalSuccess.Video"
            src={videoUrl}
            loading="lazy"
            className="w-full h-full"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowFullScreen={true}
          ></iframe>
        </div>
      )}
      <Button
        onClick={() => modalInstance.resolve?.(true)}
        {...getTestProps(testId, 'go-edit')}
      >
        {t('PopulateSpaceModal.ModalSuccess.Button')}
      </Button>
    </div>
  );
};

export default PopulateSpaceReadyModal;
